import { useActivityDataReport } from "../../api/activity-data";
import { errorToast } from "../../toast";
import { downloadBlobAsCsv } from "../../utils/downloadBlobAsCsv";
import Card from "../Card";
import DownloadActivityReportForm from "./DownloadActivityReportForm";
import { DownloadActivityDataReportFormValuesWithFormattedDates } from "./DownloadActivityReportFormValues";

const DownloadActivityReportCard = () => {
    const [downloadActivityDataReport, isDownloadingActivityDataReport] =
        useActivityDataReport();

    const handleDownloadActivityDataReport = async (
        values: DownloadActivityDataReportFormValuesWithFormattedDates
    ) => {
        const response = await downloadActivityDataReport(undefined, {
            ...values,
        });

        if (!response.success) {
            errorToast(
                "There was a problem downloading report - please try again"
            );
            return;
        }

        const fileName = `${values.type}-${values.fromDate}-to-${values.toDate}.csv`;

        downloadBlobAsCsv(response.content, fileName);
    };

    return (
        <Card className="p-6">
            <DownloadActivityReportForm
                onSubmit={handleDownloadActivityDataReport}
                isSubmitting={isDownloadingActivityDataReport}
            />
        </Card>
    );
};

export default DownloadActivityReportCard;
